import React, { useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import MessengerUserRow from "apps/messenger/components/shared/MessengerUserRow";

import ScaleFadeTransition from "shared/components/ScaleFadeTransition";
import ClickWatcher from "shared/components/ClickWatcher";

import "apps/messenger/components/OverflowMenu/index.scss";

const OverflowMenu = ({ conversations, openConversation, closeConversation }) => {
	// Set and toggle the overflowVisible state.
	const [overflowVisible, setOverflowVisible] = useState(false);
	const toggleOverflowVisible = useCallback(
		() => setOverflowVisible(!overflowVisible),
		[overflowVisible]
	);

	const onOpen = useCallback((...args) => {
		toggleOverflowVisible();
		openConversation(...args);
	}, [toggleOverflowVisible, openConversation]);

	const onClose = useCallback((...args) => {
		toggleOverflowVisible();
		closeConversation(...args);
	}, [toggleOverflowVisible, closeConversation]);

	// Check if the hidden conversations have any unread messages.
	const hiddenConversationUnreads = useMemo(
		() => conversations.some(({ unreadCount }) => unreadCount > 0),
		[conversations]
	);

	return (
		<ClickWatcher
			className={classnames("messenger-overflow", {
				"messenger-overflow--hasUnreads": hiddenConversationUnreads
			})}
			onOutsideClick={toggleOverflowVisible}
			onInsideClick={toggleOverflowVisible}
			active={overflowVisible}
		>
			<button
				className="messenger-overflow-button"
				onClick={toggleOverflowVisible}
			>
				<span className="icon i-messages" />
				{conversations.length}
			</button>

			<ScaleFadeTransition speed={ScaleFadeTransition.speeds.Half}>
				{overflowVisible && (
					<div className="messenger-overflow-user-buttons">
						{conversations.map(({ fields: user, unreadCount }) => (
							<MessengerUserRow
								key={user.userid}
								className="messenger-overflow-user-button"
								onOpen={onOpen}
								onClose={onClose}
								unreadCount={unreadCount}
								{...user}
							/>
						))}
					</div>
				)}
			</ScaleFadeTransition>
		</ClickWatcher>
	);
};

OverflowMenu.propTypes = {
	conversations: PropTypes.array.isRequired,

	openConversation: PropTypes.func.isRequired,
	closeConversation: PropTypes.func.isRequired,
};

export default OverflowMenu;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/OverflowMenu/index.jsx